import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";

import { MwcAlertModule } from 'mwc/alert';
import { MwcButtonModule } from 'mwc/button';
import { MwcDropDownModule } from 'mwc/dropdown';
import { MwcGridModule } from "mwc/grid";
import { MwcIconModule } from "mwc/icon";
import { MwcInputModule } from "mwc/input";
import { MwcMenuModule } from 'mwc/menu';
import { MwcPopoverModule } from 'mwc/popover';
import { MwcSelectModule } from 'mwc/select';

import { GithubButtonComponent } from './github-button.component';
import { HeaderComponent } from './header.component';
import { LogoComponent } from './logo.component';
import { NavigationComponent } from './navigation.component';
import { SearchbarComponent } from './searchbar.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    HttpClientModule,
    MwcGridModule,
    MwcIconModule,
    MwcInputModule,
    MwcMenuModule,
    MwcSelectModule,
    MwcButtonModule,
    MwcDropDownModule,
    MwcPopoverModule,
    MwcAlertModule
  ],
  declarations: [
    HeaderComponent,
    LogoComponent,
    SearchbarComponent,
    NavigationComponent,
    GithubButtonComponent
  ],
  exports: [HeaderComponent]
})
export class HeaderModule {

}
